import React, { useEffect } from "react";

import {
  Outlet,
  useLocation,
  useNavigate
} from "react-router-dom";

import Sidebar from "../pages/Sidebar";

import "./DashboardLayout.css";

export default function DashboardLayout() {

  const location = useLocation();

  const navigate = useNavigate();

  const user =
    JSON.parse(localStorage.getItem("user")) || {};

  // LOGIN PROTECTION
  useEffect(() => {

    if (!user.id) {

      navigate("/");

    }

  }, [navigate, user.id]);

  const getTitle = () => {

    if (location.pathname.includes("create-ticket")) {
      return "Create Ticket";
    }

    if (location.pathname.includes("my-tickets")) {
      return "My Tickets";
    }

    if (location.pathname.includes("profile")) {
      return "Profile";
    }

    if (location.pathname.includes("ticket/view")) {
      return "Ticket Details";
    }

    if (location.pathname.includes("ticket/edit")) {
      return "Edit Ticket";
    }

    return "Dashboard";
  };

  return (

    <div className="layout">

      {/* SIDEBAR */}
      <Sidebar />

      <div className="main">

        {/* TOPBAR */}
        <div className="topbar">

          <h2>{getTitle()}</h2>

          <span>
            Welcome,
            {" "}
            {user.first_name}
            {" "}
            {user.last_name}
          </span>

        </div>

        {/* PAGE CONTENT */}
        <div className="content">

          <Outlet />

        </div>

      </div>

    </div>

  );
}